import { isDevelopment, isProduction, isStaging } from '../errorReporting';

const isSentryEnabled = () =>
  Boolean(
    process.env.ENABLE_SENTRY &&
      (isDevelopment() || isStaging() || isProduction()),
  );
export default isSentryEnabled;
